<template lang="pug">
div(v-if="this.opens.length")
  v-dialog.overflow-hidden(
    v-for="({ img, link }, i) in items",
    v-model="opens[i].open",
    :key="i",
    width="max-content"
  )
    .relative.popup-widget-card-wrap
      v-card.popup-widget-card(
        :href="link",
        target="_blank",
        width="max-content"
      )
        img.popup-widget-img.d-block(:src="files + img")
      v-btn.mt-n3.mr-n3(
        @click="() => (opens[i].open = false)",
        color="white",
        absolute,
        top,
        right,
        icon,
        ssss,
        small
      )
        v-icon fas fa-times
</template>

<script>
export default {
  data: () => ({
    opens: [],
  }),
  computed: {
    items() {
      return this.$rest("popups").list;
    },
  },
  created() {
    this.$rest("popups")
      .get()
      .then((data) => {
        this.opens = data.map(() => ({
          open: true,
        }));
      });
  },
};
</script>

<style>
.popup-widget-card,
.popup-widget-card-wrap,
.popup-widget-img {
  max-height: calc(100vh - 50px) !important;
}

.popup-widget-img {
  max-width: 600px;
  width: 100%;
}
</style>
